<template>
    <div :class="buttonsClass">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            align: { type: String, default: 'center' },
            isDisabled: { type: Boolean, default: false },
            mobileDirection: { type: String, default: 'reverse' },
        },

        computed: {
            buttonsClass() {
                return {
                    buttons: true,
                    [`buttons--align-${this.align}`]: this.align,
                    [`buttons--mobile-${this.mobileDirection}`]: true,
                    'buttons--is-disabbled': this.isDisabled,
                }
            },
        },
    }
</script>
